export default __webpack_public_path__ + "static/media/generador-seguridad.5d81cca8.jpg";